import { number, object, ObjectSchema, string } from 'yup'
import { get } from 'svelte/store'
import { t } from '../../../i18n/i18n'

export type MailTemplateEntry = {
	id: string
	mailName: string
	mailTemplateId: string
	daysUntilDeletion: number
}

export const mailTemplateEntrySchema: ObjectSchema<{}, MailTemplateEntry, {}, ''> = object({
	id: string().required(get(t)('UI.MailConfig.template.id.required')),
	mailName: string().required(get(t)('UI.MailConfig.template.mailName.required')),
	mailTemplateId: string().required(get(t)('UI.MailConfig.template.mailTemplateId.required')),
	daysUntilDeletion: number()
		.typeError(get(t)('UI.MailConfig.template.daysUntilDeletion.number'))
		.required(get(t)('UI.MailConfig.template.daysUntilDeletion.required'))
		.min(1, get(t)('UI.MailConfig.template.daysUntilDeletion.greaterOne'))
})
